import React from 'react';
import ChecklistElement from './ChecklistElementModel';
import EditorType from '../../../Enums/EditorType';
import type { JSX } from 'react';
import { QuickTextInput } from 'shouldve-been-mui';

class TextAreaChecklistElement extends ChecklistElement {

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number) {

        super(elementId, name, itemNumber, sortNumber, EditorType.TEXTAREA);
    }

    public buildFormElement(value: string, onBlur: (value: string) => Promise<void>, screenWidth: number): JSX.Element {

        return (
            <React.Fragment key={this.elementId}>
                <QuickTextInput
                    value={value}
                    onBlur={onBlur}
                    variant='outlined'
                    dense={true}
                    minWidth={Math.min(screenWidth * 0.8, 500)}
                    maxWidth={Math.min(screenWidth * 0.8, 500)}
                    labelText={this.name}
                    multiline={true}
                    minRows={3}
                />
                <br />
                <br />
            </React.Fragment>
        );
    }
}

export default TextAreaChecklistElement;